import { Component, inject, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent, ToggleButtonComponent } from '@letly/ui-common';
import { MediaService } from '@letly/services';
import { ConsentMechanism, ConsentService } from '../services/consent.service';
import { COOKIE_NOTICE_URL } from '../services/consent.config';

@Component({
  selector: 'app-consent-panel',
  imports: [FormsModule, ButtonComponent, ToggleButtonComponent],
  templateUrl: './consent-panel.component.html',
  standalone: true
})
export class ConsentPanelComponent {
  private readonly consentService = inject(ConsentService);
  private readonly mediaService = inject(MediaService);

  readonly mechanism = input.required<ConsentMechanism>();
  readonly decided = output<void>();

  readonly cookieNoticeUrl = COOKIE_NOTICE_URL;

  readonly layer = signal<1 | 2>(1);
  readonly analyticsChoice = signal(false);
  readonly attributionChoice = signal(false);

  readonly stepMode = this.mediaService.isMobile;

  acceptAll(): void {
    this.consentService.acceptAll(this.mechanism());
    this.decided.emit();
  }

  rejectAll(): void {
    this.consentService.rejectAll(this.mechanism());
    this.decided.emit();
  }

  saveChoices(): void {
    this.consentService.save(
      { analytics: this.analyticsChoice(), attribution: this.attributionChoice() },
      this.mechanism()
    );
    this.decided.emit();
  }
}
